export default "__VITE_ASSET__Bi6TzwmC__"